var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("polyline",{"stroke":"currentcolor","fill":"none","points":"1.15307617 6.847229 6.9956665 1.15771484 12.859314 6.85333252"})));
}

Chevron.defaultProps = {"width":"14px","height":"8px","viewBox":"0 0 14 8","version":"1.1"};

module.exports = Chevron;

Chevron.default = Chevron;
